import request from '@/utils/request'

// 查询班级管理列表
export function listClasses(query) {
  return request({
    url: '/OmdClasses/classes/list',
    method: 'get',
    params: query
  })
}

// 查询班级管理详细
export function getClasses(id) {
  return request({
    url: '/OmdClasses/classes/' + id,
    method: 'get'
  })
}

// 新增班级管理
export function addClasses(data) {
  return request({
    url: '/OmdClasses/classes',
    method: 'post',
    data: data
  })
}

// 修改班级管理
export function updateClasses(data) {
  return request({
    url: '/OmdClasses/classes',
    method: 'put',
    data: data
  })
}

// 删除班级管理
export function delClasses(id) {
  return request({
    url: '/OmdClasses/classes/' + id,
    method: 'delete'
  })
}
